import * as attackStages from 'components/attacks/utils/attack-stages'
import {
  scenarioGraphTypes,
  isInfraAttackNode
} from 'components/scenarios/utils/graph'
import theme from 'theme'

export const NODE_TYPE_COLOR = {
  [scenarioGraphTypes.InfraAttack]: 'blue',
  [scenarioGraphTypes.SynchronousStatusCheck]: 'green',
  [scenarioGraphTypes.ContinuousStatusCheck]: 'green'
}

export const dotTypeColors = {
  red: theme.colors.red[0],
  blue: theme.colors.blue[0],
  gray: theme.colors.steel[1],
  green: theme.colors.green[0],
  yellow: theme.colors.yellow[0]
}

const DOT_COLOR = {
  ACTIVE: dotTypeColors.blue,
  SUCCESSFUL: dotTypeColors.green,
  HALTED: dotTypeColors.yellow,
  HALT_REQUESTED: dotTypeColors.red,
  FAILED: dotTypeColors.red,
  NOT_STARTED: dotTypeColors.gray
}

const findLifecycleType = (lifecycle) =>
  Object.keys(DOT_COLOR).find((key) =>
    LIFECYCLE[key].some((colorState) => colorState === lifecycle)
  )

export const getColorByState = (step) => {
  const state = Object.entries(getStateOfNodeByType(step)).find(
    ([key, value]) =>
      value === true && ['isCompleted', 'isNotStarted'].indexOf(key) === -1
  )

  const lifecycle = Object.entries(LIFECYCLE).find(
    ([, value]) => value.indexOf(state[0].replace('is', '')) === 0
  )

  return DOT_COLOR[lifecycle[0]]

  //return findLifecycleType(lifecycle)
}

export const LIFECYCLE = {
  NOT_STARTED: ['NotStarted'],
  ACTIVE: ['Active'],
  SUCCESSFUL: ['Successful'],
  HALTED: ['Halted'],
  HALT_REQUESTED: ['HaltRequested'],
  FAILED: ['Failed']
}

export const FINISHED_LIFECYCLE = [
  ...LIFECYCLE.SUCCESSFUL,
  ...LIFECYCLE.FAILED,
  ...LIFECYCLE.HALTED,
  ...LIFECYCLE.HALT_REQUESTED
]

export const getStateOfNodeByType = (summary) => {
  // InfraAttacks have specialized stages so if we have one, use those utilities, otherwise use graph lifecycle utils
  const stage = summary.state?.task_summary?.stage

  if (isInfraAttackNode(summary) && stage) {
    return {
      isNotStarted: attackStages.isInNotStartedStage(stage),
      isActive: attackStages.isInActiveStage(stage),
      isCompleted: attackStages.isInCompleteStage(stage),
      isHalted: attackStages.isInHaltingStage(stage),
      isFailed: attackStages.isInFailedStage(stage),
      isSuccessful: attackStages.isInSuccessfulStage(stage)
    }
  }
  const lifecycle = summary.state?.lifecycle ?? 'NotStarted'
  return {
    isNotStarted: isNotStarted(lifecycle),
    isActive: isActive(lifecycle),
    isCompleted: isComplete(lifecycle),
    isHalted: isHalted(lifecycle),
    isHaltRequested: isHaltRequested(lifecycle),
    isFailed: isFailed(lifecycle),
    isSuccessful: isSuccessful(lifecycle)
  }
}

// Stage
export const getLifecycleColor = (lifecycle) =>
  DOT_COLOR[findLifecycleType(lifecycle)]
export const getTypeColor = (type) => NODE_TYPE_COLOR[type] ?? 'gray'
export const getColor = (lifecycle) =>
  getLifecycleColor(lifecycle) ?? getTypeColor(lifecycle)
export const isComplete = (lifecycle) => FINISHED_LIFECYCLE.includes(lifecycle)
export const isActive = (lifecycle) => LIFECYCLE.ACTIVE.includes(lifecycle)
export const isNotStarted = (lifecycle) =>
  LIFECYCLE.NOT_STARTED.includes(lifecycle)
export const isHalted = (lifecycle) =>
  LIFECYCLE.HALTED.includes(lifecycle) ||
  LIFECYCLE.HALT_REQUESTED.includes(lifecycle)
export const isHaltRequested = (lifecycle) =>
  LIFECYCLE.HALT_REQUESTED.includes(lifecycle)
export const isFailed = (lifecycle) => LIFECYCLE.FAILED.includes(lifecycle)
export const isSuccessful = (lifecycle) =>
  LIFECYCLE.SUCCESSFUL.includes(lifecycle)
